import React from 'react';
import * as Yup from 'yup';
import { Form, Formik, Field } from 'formik';
import { Button, FormRow, Map, DateFormWidget, FileUpload } from '../controls';

const StageSchema = Yup.object().shape({
  stageName: Yup.string().required('Stage name is required'),
});

const defaultDateObject = {
  startTime: null,
  endTime: null,
  startTimeMS: null,
  endTimeMS: null,
};

export function StageForm({
  stage,
  onStageSave,
  onDateChange,
  onLocationChange,
  onFileUpload,
  onFileDelete,
}) {
  const dates = stage
    ? stage.times || [defaultDateObject]
    : [defaultDateObject];
  const defaultValues = {
    stageName: stage ? stage.stageName || '' : '',
    stageDescription: stage ? stage.stageDescription || '' : '',
  };

  const fileList = [];

  if (stage.photoURL) {
    fileList.push({
      uid: '-1',
      name: stage.photo,
      url: stage.photoURL,
      status: 'done',
    });
  }

  return (
    <div className="py-4">
      <Formik
        enableReinitialize
        initialValues={defaultValues}
        onSubmit={onStageSave}
        validationSchema={StageSchema}
      >
        {() => (
          <Form>
            <div className="flex items-start">
              <div className="w-3/4 p-4">
                <FormRow label="Stage Name" errorName="stageName">
                  <Field
                    type="text"
                    name="stageName"
                    placeholder="Stage Name"
                  />
                </FormRow>
                <DateFormWidget
                  label="Dates & Times"
                  dates={dates}
                  handleDateChange={onDateChange}
                  allowMultiple={true}
                />
              </div>
              <div className="w-1/4 p-4">
                <FormRow>
                  <div className="w-full">
                    <FileUpload
                      fileList={fileList}
                      onFileUpload={onFileUpload}
                      onFileDelete={onFileDelete}
                    />
                  </div>
                </FormRow>
              </div>
            </div>
            <FormRow>
              <Map location={stage.location} handleClick={onLocationChange} />
            </FormRow>
            <FormRow label="General Information">
              <Field
                component="textarea"
                name="stageDescription"
                placeholder="Stage Information..."
              />
            </FormRow>
            <Button style={{ float: 'right', marginTop: '1rem' }} mode="dark">
              Save Stage
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
}
